// Procore / ACC folder slots (back/routes/folderPaths.js): per project and as company
// defaults, and shop drawings brought in from the download folders.
import { get, post, globalPut } from "api";

const ok = (p) =>
  p.then(
    (r) => {
      if (r && r.error) throw new Error(r.error);
      return r;
    },
    (e) => {
      throw e instanceof Error ? e : new Error((e && (e.error || e.message)) || "The server refused the request");
    }
  );

export const getCompanyFolderPaths = () => ok(get(`/folder-paths/company`));
export const saveCompanyFolderPaths = (provider, body) => ok(globalPut(`/folder-paths/company/${provider}`, body));
export const getProjectFolderPaths = (projectId) => ok(get(`/folder-paths/project/${projectId}`));
export const saveProjectFolderPaths = (projectId, provider, body) => ok(globalPut(`/folder-paths/project/${projectId}/${provider}`, body));
export const getRemoteShopDrawings = (projectId) => ok(get(`/folder-paths/project/${projectId}/shop-drawings`));
export const pullRemoteShopDrawings = (projectId, keys) => ok(post(`/folder-paths/project/${projectId}/shop-drawings/pull`, keys ? { keys } : {}));
